import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import api from "../../api";
import Button from "../../components/Button";
import InputField from "../../components/InputField";
import { LoaderContext } from "../../context/LoaderContext";
import {
  StyledAuthLogoContainer,
  StyledMainContainer,
} from "../../styles/global";
import { StyledRegisterCard } from "./styled";
import { FaQrcode } from "react-icons/fa";
import Header from "../../components/Header";
import { isValidEmail } from "../../helper/functions";
import SSOButton from "../../components/SSOButton";

interface Props {
  onRegisterSuccess: (token: string) => void;
}

const Register: React.FC<Props> = ({ onRegisterSuccess }) => {
  const { showLoader } = useContext(LoaderContext);
  const [state, setState] = useState({
    email: "",
    password: "",
    name: "",
  });
  const [errors, setErrors] = useState({
    nameError: "",
    emailError: "",
    passwordError: "",
  });

  const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setErrors({
      ...errors,
      [e.target.name + "Error"]: "",
    });
  };

  const hasError = () => {
    let hasError = errors;
    hasError.nameError = !state.name ? "Name is required" : "";
    hasError.emailError = !state.email
      ? "Email is required"
      : !isValidEmail(state.email)
      ? "Enter a valid email"
      : "";
    hasError.passwordError = !state.password ? "Password is required" : "";
    setErrors({ ...hasError });
    return !!(
      hasError.emailError ||
      hasError.passwordError ||
      hasError.nameError
    );
  };

  const handleRegister = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    let error = hasError();
    if (error) {
      toast.error("Please fill all the fields");
      return;
    }
    showLoader({
      show: true,
    });
    api
      .Register(state)
      .then((res) => {
        if (res.status === 201) {
          const token = res.data.data.token;
          console.log(token);
          onRegisterSuccess(token);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        showLoader({
          show: false,
        });
      });
  };
  return (
    <>
      <Header title="WhatQR" />

      <StyledMainContainer onClick={() => {}}>
        <StyledAuthLogoContainer>
          <FaQrcode />
        </StyledAuthLogoContainer>

        <StyledRegisterCard>
          <InputField
            name="name"
            placeholder="Enter your name"
            label="Name"
            type="text"
            value={state.name}
            error={errors.nameError}
            onChange={(e) => {
              setState({ ...state, name: e.target.value });
            }}
            onFocus={handleOnFocus}
          />
          <InputField
            name="email"
            placeholder="Enter your email"
            label="Email"
            type="text"
            value={state.email}
            error={errors.emailError}
            onChange={(e) => {
              setState({ ...state, email: e.target.value });
            }}
            onFocus={handleOnFocus}
          />
          <InputField
            name="password"
            placeholder="Enter your password"
            label="Password"
            type="password"
            value={state.password}
            error={errors.passwordError}
            onChange={(e) => {
              setState({ ...state, password: e.target.value });
            }}
            onFocus={handleOnFocus}
          />
          <Button
            onClick={(e) => {
              handleRegister(e);
            }}
            label="Register"
          />
          <span>
            Already have an account? <a href="/login">Login</a>
          </span>
          <p
            style={{
              textAlign: "center",
              width: "100%",
            }}
          >
            OR
          </p>
          <SSOButton id="google" />
          <SSOButton id="github" />
        </StyledRegisterCard>
      </StyledMainContainer>
    </>
  );
};

export default Register;
